import { type Ref, ref, computed } from "vue";

// Shared between quickshare's download actions and documentFunctions' download
// actions — both kinds of downloads track progress in the same map keyed by
// either itemId or requestId. Extracted into its own composable so neither
// owner has to reach across boundaries.
export const useDownloadProgressComposable = () => {
  const downloadProgressState: Ref<Record<string, number | null>> = ref({});

  const downloadProgress = computed(() => (requestId: string) => downloadProgressState.value[requestId]);

  return {
    downloadProgressState,
    downloadProgress
  };
};
